import React, { useEffect, useState } from 'react'


export function getYearWhen18() {
    const currentYear = new Date().getFullYear();  // Get the current year
    return currentYear - 18;  // Subtract 18 years from the current year to find the year when they'll be 18
}

export function compare_two_date_error(registrationForm,formErrorMessage) {
    return (`${registrationForm.dateOfBirth}`?.length > 5 && `${registrationForm.applicationDate}`?.length > 5) ? (is18OrOlder(registrationForm.dateOfBirth, registrationForm.applicationDate) === false ?
     "Under age" : formErrorMessage?.dateOfBirth) : formErrorMessage?.dateOfBirth 
}
export function getExactDateWhen18() {
    const currentDate = new Date();  // Get today's date
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth();  // 0-based month (0 = January, 11 = December)
    const currentDay = currentDate.getDate();

    // Create a new date object by subtracting 18 years from the current year
    let yearWhen18 = currentYear - 18;

    // Create the date object for when the person would turn 18 (18 years ago)
    const birthdayWhen18 = new Date(yearWhen18, currentMonth, currentDay);

    // If the current date is before their birthday this year, adjust the year
    if (currentDate < birthdayWhen18) {
        yearWhen18--;  // If not yet their birthday this year, they will turn 18 in the next year
    }

    // Return the exact date when they will turn 18 (year, month, and day)
    return new Date(yearWhen18, currentMonth, currentDay);
}
function addYearsToDate(date, years) {
    var newDate = new Date(date);
    newDate.setFullYear(newDate.getFullYear() + years);
    return newDate;
}


export function is18OrOlder(dateA, dateB) {
    if(!isValidDate(dateA) || !isValidDate(dateB))
    {
        throw new Error("Invalid date comparison.");
    }
    if (addYearsToDate(dateA, 18) > dateB) {
        return false;
    }
    else 
    {
        return true;
    }


    function isValidDate(date) {
        var parsedDate = new Date(date);  // Attempt to create a Date object from the input
        return !isNaN(parsedDate.getTime()); // If the time is NaN, it's not a valid date
    }
}

export default function UseError() {
    var [formErrors, SetFormError] = useState({})

    function Errors() {
        var obj = {};

        obj.isEligibleToVote = (input_birthDate, votingAge) => {
            var birthDate = new Date(input_birthDate); // Replace with the person's birth date
            // Get the current date
            var today = new Date();

            // Calculate the age
            var age = today.getFullYear() - birthDate.getFullYear();
            var monthDifference = today.getMonth() - birthDate.getMonth();

            // If the birth month hasn't occurred yet this year, subtract one from age
            if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }

            // Check if the age is equal to or greater than the voting age
            return age >= votingAge;
        }
        // Check if a value is a positive number
        obj.isPositiveNumber = (value) => {
            return /^\d+$/.test(value?.trim() || "")
        };

        // Check if a string is a valid date
        obj.isDate = (value) => {
            const date = new Date(value);
            return !isNaN(date.getTime());
        };

        // Check if a string is alphanumeric
        obj.isAlphaNumeric = (value) => {
            return /^[a-z0-9]+$/i.test(value);
        };

        // Check if a string is a valid name (only letters and spaces)
        obj.isName = (value) => {
            return /^[a-zA-Z\s]+$/.test(value.trim())
         // return /^[a-zA-Z]*$/.test(value.trim());
        };

        // Check if a value is not empty
        obj.haveSomething = (value) => {
            if(Array.isArray(value) && value.length > 0) return true;
            if ((value + "").trim().length === 0) {
                return false;
            }
            else {
                return true
            }
        };

        obj.haveLengthOf = (value, lengthValue) => {
            try {
                const valueStr = value.toString();
                return valueStr.length === lengthValue;
            } catch (error) {
                return false;
            }
        };
        obj.reachedLimit = (value, lengthValue) => {
            try {
                const valueStr = value.toString();
                return valueStr.length >= lengthValue;
            } catch (error) {
                return false;
            }
        };
        obj.minLength = (value, lengthValue) => {
            try {
                const valueStr = value.toString();
                return valueStr.length >= lengthValue;
            } catch (error) {
                return false;
            }
        };
        obj.isValidEmail = (value) => {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(value.trim());
        };
        // obj.OptionalUntil=(phoneNumber,Contr,form)=>{
        //          if(obj.haveSomething(form[isThere])){

        //          }
        // }
        return obj;
    }



    var proccessErrors = Errors()


    function updateForm(name, val, form) {
        var errorMessages = {}

        var exp = formErrors[name];

        var values = exp?.split("|")
        var optional = values?.at(0)

        for (let index = 0; index < values?.length; index++) {
            const submExp = values[index];
            var sub = submExp?.trim()?.split(":")

            if (optional == "optional" && proccessErrors.haveSomething(val) === false) {
                // console.log(name)
            }
            else {
                // console.log(name, submExp)
                if (submExp === "required") {
                    if (proccessErrors.haveSomething(val) === false) {
                        return `is required`
                    }
                }

                if (submExp === "email") {
                    if (!proccessErrors.isValidEmail(val)) {
                        return `is invalid`

                    }
                }

                if (submExp === "number") {

                    if (proccessErrors.isPositiveNumber(val) === false) {
                        return `must be a number`

                    }
                }


                if (submExp === "date") {
                    if (!proccessErrors.isDate(val)) {
                        return `is invalid`

                    }
                }
                if (submExp === "string") {
                    if (!proccessErrors.isName(val)) {
                        return `is invalid`

                    }
                }

                // if (sub?.at(0) === "dependOn") {
                //     var depend = sub?.at(1);
                //     var depend_called = sub?.at(2);
                //     try {
                //         var res = proccessErrors.haveSomething(form[depend])
                //         if (!res) {
                //             return `${depend_called} is required`

                //         }
                //     } catch (error) {
                //         return `${depend_called} is required`
                //     }
                // }


                if (sub?.at(0) === "startYear") {
                    var res = proccessErrors.isEligibleToVote(val, parseInt(sub?.at(1)))
                    if (res === false) {
                        return `Applicant under age`
                    }

                }
                if (sub?.at(0) === "limit") {
                    var res = proccessErrors.reachedLimit(val, parseInt(sub?.at(1)))
                    if (res) {
                        return `limit is ${sub?.at(1)}`
                    }

                }

                if (sub?.at(0) === "compareDate") {
                    var sameAs = sub?.at(1);
                    var sameAsName = sub?.at(2);

                    try {
                        if (is18OrOlder(val, form[sameAs]) === false) {
                            return `Under age`
                        }
                    } catch (error) {
                        console.log(error)
                        return `Invalid date comparison.`
                    }

                }

                if (sub?.at(0) === "sameAs") {
                    var sameAs = sub?.at(1);
                    var sameAsName = sub?.at(2);
                    try {
                        if (val.trim() !== form[sameAs]) {
                            return `${sameAsName}s are not the same`
                        }
                    } catch (error) {
                        return `${sameAsName}s are not the same`
                    }

                }

                if (sub?.at(0) === "max") {
                    var res = proccessErrors.haveLengthOf(val, parseInt(sub?.at(1)))
                    if (!res) {
                        return `length must be ${sub?.at(1)}`

                    }

                }
                if (sub?.at(0) === "min") {
                    var res = proccessErrors.minLengthn(val, parseInt(sub?.at(1)))

                    if (!res) {
                        return ` should be at least ${sub?.at(1)}`
                    }

                }


            }
        }

        return "";

    }


    return { SetFormError, updateForm, formErrors }
}
